export enum ROUTES {
  // Aktiver Messpunkt
  AKTIVEMESSPUNKTE = "/AktiverMesspunkt",
  AKTIVEMESSPUNKTID = "/AktiverMesspunkt/idToReplace1",
  POSTAKTIVEMESSPUNKTE = "/AktiverMesspunkt/Get",

  // Anlagen
  ANLAGEN = "/Anlagen",
  ANLAGEID = "/Anlagen/idToReplace1",
  ANLAGENTYPEN = "/Anlagen/Typ",

  // Anomalie
  ANOMALIE = "/Anomalie",
  ANOMALIEGENERALTABLE = "/Anomalie/GetTabelle",
  ANOMALIEDETAILEDTABLE = "/Anomalie/GetDetailtabelle",

  //Backend
  BACKEND = "/backend/idToReplace1",

  // Betriebserignis
  BETRIEBSEREIGNISSE = "/Betriebsereignis",
  BETRIEBSEREIGNISID = "/Betriebsereignis/idToReplace1",
  BETRIEBSSTATUS = "/Betriebsstatus",
  DATENVOLLSTEANDIGKEIT = "/Datenvollstaendigkeit",
  KOMMUNIKATION = "/Kommunikationsstatus",

  // Datenfeld
  DATENFELDKATEGORIEN = "/Datenfeld/Kategorie",
  DATENFELDKATEGORIEID = "/Datenfeld/Kategorie/idToReplace1",
  DATENKLASSENID = "/Datenfeld/Klasse/idToReplace1",
  DATENFELDER = "/Datenfeld",
  KENNGROESSE = "/Datenfeld/Kenngroesse",

  // Dokumente
  DOKUMENTE = "/Dokumente",
  DOKUMENTID = "/Dokumente/idToReplace1",
  DOKUMENT = "/Dokumente/Datei",
  DATEIID = "/Dokumente/Datei/idToReplace1",

  // Firewallantrag

  FIREWALLANTRAGREQUEST = "/FirewallAntrag",
  GETFIREWALLANTRAG = "/FirewallAntrag/idToReplace1",
  UPLOADFIREWALLANTRAG = "/FirewallAntrag/idToReplace1",
  SENDFIREWALLANTRAG = "/FirewallAntrag/idToReplace1/send",
  GENERATEFIREWALLANTRAG = "/FirewallAntrag/idToReplace1/generate",
  GENERATENI = "/FirewallAntrag/idToReplace1/generateNI",
  GENERATESI = "/FirewallAntrag/idToReplace1/generateSI",

  // Geflaggter Messwert
  MESSWERTEGEFLAGGTID = "/GeflaggterMesswert/idToReplace1",
  POSTMESSWERTEGEFLAGGT = "/GeflaggterMesswert/Get",

  // Grenzwert
  GRENZWERTSATZ = "/Grenzwert/Name",

  // Gruppe
  GRUPPE = "/Gruppe",
  GRUPPEID = "/Gruppe/idToReplace1",
  GRUPPENZUORDNUNG = "/Gruppe/Zuordnung",
  GRUPPENZUORDNUNGID = "/Gruppe/Zuordnung/idToReplace1/idToReplace2",
  GRUPPENTYP = "/Gruppe/Typ",

  // Health
  HEALTH = "/Health/General",

  // Konfig
  KONFIG = "/Konfig",
  KONFIGID = "/Konfig/idToReplace1",
  GESPEICHERTESUCHEN = "/Konfig/GespeicherteSuche",

  // Korrelation
  KORRELATIONCALCULATE = "/Korrelation/Calculate",
  KORRELATIONLIST = "/Korrelation/List",
  KORRELATIONGET = "/Korrelation/Get",

  // Messgerät
  MESSGERAET = "/Messgeraet",
  MESSGERAETID = "/Messgeraet/idToReplace1",

  //Messgerättyp
  MESSGERAETTYP = "/Messgeraettyp",
  MESSGERAETTYPID = "/Messgeraettyp/idToReplace1",

  // Messstelle
  MESSSTELLE = "/Messstelle",
  MESSSTELLEID = "/Messstelle/idToReplace1",

  // Messwert
  MESSWERT = "Messwert/Get",
  FIRSTANDLASTMESSWERT = "/Messwert/GetFirstLastTimestamp",
  MESSWERTLOG = "Messwert/GetLog",
  PQEREIGNIS = "/Messwert/PqEreignis",
  PQSTATUS = "/Messwert/PqStatus",
  PQSTATUSGRUPPE = "/Messwert/PqStatusGruppe",
  PQSTATUSMESSSTELLE = "/Messwert/PqStatusMessstelle",
  //Export
  MESSWERTEXPORTEXCEL = "MesswertExport/Get",
  // Netzereignisse
  NETZEREIGNIS = "/Netzereignis",
  NETZEREIGNISID = "/Netzereignis/idToReplace1",
  FREISCHALTUNG = "/Netzereignis/Freischaltung",

  // PQ_Index
  PQINDEXMESSSTELLEKENNGROESSE = "/PqIndex/GetMessstelleKenngroesse",
  PQINDEXMESSSTELLEZEIT = "/PqIndex/GetMessstelleZeit",
  PQINDEXKENNGROESSEZEIT = "/PqIndex/GetKenngroesseZeit",

  // Request
  REQUEST = "/Request/GetRequestThatExcededMaxRetries",
  RESETREQUEST = "/Request/Reset/idToReplace1",

  // Router
  ROUTER = "/Router",
  ROUTERID = "/Router/idToReplace1",

  // Routertyp
  ROUTERTYP = "/Routertyp",
  ROUTERTYPID = "/Routertyp/idToReplace1",

  // Schaltfeld
  SCHALTFELD = "/Schaltfeld",
  SCHALTFELDID = "/Schaltfeld/idToReplace1/idToReplace2",

  // Spannungsebene
  SPANNUNGSEBENE = "/Spannungsebene",
  SPANNUNGSEBENEID = "/Spannungsebene/idToReplace1",

  // Spannungswandler
  SPANNUNGSWANDLER = "/Spannungswandler",
  SPANNUNGSWANDLERID = "/Spannungswandler/idToReplace1",

  // Störung
  STOERUNG = "/Stoerung",
  STOERUNGID = "/Stoerung/idToReplace1",
  STOERUNGGRAPHENZUORDNUNGID = "/Stoerung/idToReplace1/Graphenzuordnung",
  STOERUNGIDANHANG = "/Stoerung/idToReplace1/Anhang",
  STOERUNGSANHANG = "/Stoerung/Anhang",
  STOERUNGSANHANGID = "/Stoerung/Anhang/idToReplace1",

  // Stromwandler
  STROMWANDLER = "/Stromwandler",
  STROMWANDLERID = "/Stromwandler/idToReplace1",

  // Trends
  TRENDSCALCULATE = "/trends/calculate",
  TRENDSLIST = "/trends/list",
  TRENDSTABELLE = "/trends/gettabelle",
  TRENDSGRAPH = "/trends/getgraph",

  // Umspannwerk
  UMSPANNWERK = "/Umspannwerk",
  UMSPANNWERKID = "/Umspannwerk/idToReplace1",

  // Wartungsintervall
  WARTUNGSINTERVALL = "Wartungsintervall",
  WARTUNGSINTERVALLID = "Wartungsintervall/idToReplace1",

  // Zeitsynchronisationsart
  ZEITSYNCHRONISATIONSART = "/Zeitsynchronisationsart",
  ZEITSYNCHRONISATIONSARTID = "/Zeitsynchronisationsart/idToReplace1",
}

export const PATHS: { [key: string]: string } = {
  // Aktiver Messpunkt
  AKTIVEMESSPUNKTE: "/AktiverMesspunkt",
  AKTIVEMESSPUNKTID: "/AktiverMesspunkt/idToReplace1",
  POSTAKTIVEMESSPUNKTE: "/AktiverMesspunkt/Get",

  // Anlagen
  ANLAGEN: "/Anlagen",
  ANLAGEID: "/Anlagen/idToReplace1",
  ANLAGENTYPEN: "/Anlagen/Typ",

  // Anomalie
  ANOMALIE: "/Anomalie",
  ANOMALIEGENERALTABLE: "/Anomalie/GetTabelle",
  ANOMALIEDETAILEDTABLE: "/Anomalie/GetDetailtabelle",

  //Backend
  BACKEND: "/backend/idToReplace1",

  // Betriebserignis
  BETRIEBSEREIGNISSE: "/Betriebsereignis",
  BETRIEBSEREIGNISID: "/Betriebsereignis/idToReplace1",
  BETRIEBSSTATUS: "/Betriebsstatus",
  DATENVOLLSTEANDIGKEIT: "/Datenvollstaendigkeit",
  KOMMUNIKATION: "/Kommunikationsstatus",

  // Datenfeld
  DATENFELDKATEGORIEN: "/Datenfeld/Kategorie",
  DATENFELDKATEGORIEID: "/Datenfeld/Kategorie/idToReplace1",
  DATENKLASSENID: "/Datenfeld/Klasse/idToReplace1",
  DATENFELDER: "/Datenfeld",
  KENNGROESSE: "/Datenfeld/Kenngroesse",

  // Dokumente
  DOKUMENTE: "/Dokumente",
  DOKUMENTID: "/Dokumente/idToReplace1",
  DOKUMENT: "/Dokumente/Datei",
  DATEIID: "/Dokumente/Datei/idToReplace1",

  // Firewallantrag
  FIREWALLANTRAGREQUEST: "/FirewallAntrag",
  GETFIREWALLANTRAG: "/FirewallAntrag/idToReplace1",
  UPLOADFIREWALLANTRAG: "/FirewallAntrag/idToReplace1",
  SENDFIREWALLANTRAG: "/FirewallAntrag/idToReplace1/send",
  GENERATEFIREWALLANTRAG: "/FirewallAntrag/idToReplace1/generate",
  GENERATENI: "/FirewallAntrag/idToReplace1/generateNI",
  GENERATESI: "/FirewallAntrag/idToReplace1/generateSI",

  // Geflaggter Messwert
  MESSWERTEGEFLAGGTID: "/GeflaggterMesswert/idToReplace1",
  POSTMESSWERTEGEFLAGGT: "/GeflaggterMesswert/Get",

  // Grenzwert
  GRENZWERTSATZ: "/Grenzwert/Name",

  // Gruppe
  GRUPPE: "/Gruppe",
  GRUPPEID: "/Gruppe/idToReplace1",
  GRUPPENZUORDNUNG: "/Gruppe/Zuordnung",
  GRUPPENZUORDNUNGID: "/Gruppe/Zuordnung/idToReplace1/idToReplace2",
  GRUPPENTYP: "/Gruppe/Typ",

  // Health
  HEALTH: "/Health/General",

  // Konfig
  KONFIG: "/Konfig",
  KONFIGID: "/Konfig/idToReplace1",
  GESPEICHERTESUCHEN: "/Konfig/GespeicherteSuche",

  // Korrelation
  KORRELATIONCALCULATE: "/Korrelation/Calculate",
  KORRELATIONLIST: "/Korrelation/List",
  KORRELATIONGET: "/Korrelation/Get",

  // Messgerät
  MESSGERAET: "/Messgeraet",
  MESSGERAETID: "/Messgeraet/idToReplace1",

  //Messgerättyp
  MESSGERAETTYP: "/Messgeraettyp",
  MESSGERAETTYPID: "/Messgeraettyp/idToReplace1",

  // Messstelle
  MESSSTELLE: "/Messstelle",
  MESSSTELLEID: "/Messstelle/idToReplace1",

  // Messwert
  MESSWERT: "Messwert/Get",
  FIRSTANDLASTMESSWERT: "/Messwert/GetFirstLastTimestamp",
  MESSWERTLOG: "Messwert/GetLog",
  PQEREIGNIS: "/Messwert/PqEreignis",
  PQSTATUS: "/Messwert/PqStatus",
  PQSTATUSGRUPPE: "/Messwert/PqStatusGruppe",
  PQSTATUSMESSSTELLE: "/Messwert/PqStatusMessstelle",
  //Export
  MESSWERTEXPORTEXCEL: "MesswertExport/Get",
  // Netzereignisse
  NETZEREIGNIS: "/Netzereignis",
  NETZEREIGNISID: "/Netzereignis/idToReplace1",
  FREISCHALTUNG: "/Netzereignis/Freischaltung",

  // PQ_Index
  PQINDEXMESSSTELLEKENNGROESSE: "/PqIndex/GetMessstelleKenngroesse",
  PQINDEXMESSSTELLEZEIT: "/PqIndex/GetMessstelleZeit",
  PQINDEXKENNGROESSEZEIT: "/PqIndex/GetKenngroesseZeit",

  // Request
  REQUEST: "/Request/GetRequestThatExcededMaxRetries",
  RESETREQUEST: "/Request/Reset/idToReplace1",

  // Router
  ROUTER: "/Router",
  ROUTERID: "/Router/idToReplace1",

  // Routertyp
  ROUTERTYP: "/Routertyp",
  ROUTERTYPID: "/Routertyp/idToReplace1",

  // Schaltfeld
  SCHALTFELD: "/Schaltfeld",
  SCHALTFELDID: "/Schaltfeld/idToReplace1/idToReplace2",

  // Spannungsebene
  SPANNUNGSEBENE: "/Spannungsebene",
  SPANNUNGSEBENEID: "/Spannungsebene/idToReplace1",

  // Spannungswandler
  SPANNUNGSWANDLER: "/Spannungswandler",
  SPANNUNGSWANDLERID: "/Spannungswandler/idToReplace1",

  // Störung
  STOERUNG: "/Stoerung",
  STOERUNGID: "/Stoerung/idToReplace1",
  STOERUNGGRAPHENZUORDNUNGID: "/Stoerung/idToReplace1/Graphenzuordnung",
  STOERUNGIDANHANG: "/Stoerung/idToReplace1/Anhang",
  STOERUNGSANHANG: "/Stoerung/Anhang",
  STOERUNGSANHANGID: "/Stoerung/Anhang/idToReplace1",

  // Stromwandler
  STROMWANDLER: "/Stromwandler",
  STROMWANDLERID: "/Stromwandler/idToReplace1",

  // Trends
  TRENDSCALCULATE: "/trends/calculate",
  TRENDSLIST: "/trends/list",
  TRENDSTABELLE: "/trends/gettabelle",
  TRENDSGRAPH: "/trends/getgraph",

  // Umspannwerk
  UMSPANNWERK: "/Umspannwerk",
  UMSPANNWERKID: "/Umspannwerk/idToReplace1",

  // Wartungsintervall
  WARTUNGSINTERVALL: "Wartungsintervall",
  WARTUNGSINTERVALLID: "Wartungsintervall/idToReplace1",

  // Zeitsynchronisationsart
  ZEITSYNCHRONISATIONSART: "/Zeitsynchronisationsart",
  ZEITSYNCHRONISATIONSARTID: "/Zeitsynchronisationsart/idToReplace1",
};
